// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Navigate, Outlet } from 'react-router-dom';
// import { refreshAccessToken } from '../redux/slice/auth.slice';

// function PrivateRoutes(props) {
//     const { isAuthenticated } = useSelector((state) => state.auth);

//     console.log(isAuthenticated);

//     const dispatch = useDispatch();

//     useEffect(() => {
//         dispatch(refreshAccessToken());
//     }, [dispatch]);

//     return (
//         isAuthenticated ? <Outlet /> : <Navigate to="/" replace />
//     );
// }

// export default PrivateRoutes;

// import React, { useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Navigate, Outlet } from 'react-router-dom';
// import { refreshAccessToken } from '../redux/slice/auth.slice';

// function PrivateRoutes() {
//     const { isAuthenticated, isLoggedOut } = useSelector((state) => state.auth);

//     // console.log("Is authenticated:", isAuthenticated);
//     // console.log("Is logged out:", isLoggedOut);

//     const dispatch = useDispatch();

//     useEffect(() => {
//         if (isAuthenticated && !isLoggedOut) {
//             dispatch(refreshAccessToken());
//         }
//     }, [dispatch, isAuthenticated, isLoggedOut]);


//     return (
//         isAuthenticated ? <Outlet /> : <Navigate to="/"  />
//     );
// }

// export default PrivateRoutes;

import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { checkAuth } from '../redux/slice/auth.slice';

function PrivateRoutes() {
    const [loading, setLoading] = useState(true);
    const { isAuthenticated } = useSelector((state) => state.auth);

    // console.log("isAuthenticated====", isAuthenticated);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuthState = async () => {
            try {
                await dispatch(checkAuth());
            } catch (error) {
                navigate("/");
            } finally {
                setLoading(false);
            }
        }

        checkAuthState();
    }, [dispatch, navigate])

    if (loading) {
        return <div>Loading...</div>
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
}

export default PrivateRoutes;
